import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { alpha, type SxProps, type Theme, useTheme } from '@mui/material/styles'

import { Text } from '@mxenabled/mxui'

import { ReactComponent as Left } from './images/CouponLeft.svg'
import { ReactComponent as LeftDark } from './images/CouponLeftDark.svg'
import { ReactComponent as Perferation } from './images/CouponPerferation.svg'

interface CouponProps {
  amount: string
  label: string
  sx?: SxProps<Theme>
}

const Coupon = ({ amount, label, sx }: CouponProps) => {
  const theme = useTheme()

  return (
    <Box sx={{ p: 16, ...sx }}>
      <Stack sx={{ flexDirection: 'row' }}>
        <Stack
          sx={{
            bgcolor: 'background.paper',
            borderBottomLeftRadius: '8px',
            borderTopLeftRadius: '8px',
            p: 4,
            pr: 2,
          }}
        >
          {theme.palette.mode === 'dark' ? <LeftDark /> : <Left />}
        </Stack>
        <Stack
          sx={{
            svg: {
              path: {
                '&:not([stroke])': {
                  fill: theme.palette.background.paper,
                },
                '&[stroke]': {
                  stroke: alpha(theme.palette.divider, 0.24),
                },
              },
              rect: {
                fill: theme.palette.background.paper,
              },
            },
          }}
        >
          <Perferation />
        </Stack>
        <Stack
          sx={{
            bgcolor: 'background.paper',
            borderBottomRightRadius: '12px',
            borderTopRightRadius: '12px',
            height: 74,
            justifyContent: 'center',
            px: 12,
            width: 214,
          }}
        >
          <Text color="text.secondary" variant="caption">
            {label}
          </Text>
          <Text variant="h1">{amount}</Text>
        </Stack>
      </Stack>
    </Box>
  )
}

export default Coupon
